<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 5H13C13.5523 5 14 5.44772 14 6V14C14 14.5523 13.5523 15 13 15H3C2.44772 15 2 14.5523 2 14V5Z"
        stroke="var(--icon-color)" stroke-width="2" />
    <path d="M2 7V3C2 2.44772 2.44772 2 3 2H9C10.1046 2 11 2.89543 11 4V4.5" stroke="var(--icon-color)" stroke-width="2" />
</svg>
